import React from "react";
import { Dialog, DialogContent, Box } from "@mui/material";
import StepUpSpinner from "../Loader/StepUpSpinner";

interface LoadingDialogProps {
  open: boolean;
  title?: string;
  message?: string;
}

const LoadingDialog: React.FC<LoadingDialogProps> = ({
  open,
  title = "Processing",
  message,
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      PaperProps={{ sx: { borderRadius: "16px", minWidth: 240, boxShadow: "0 8px 32px rgba(0,0,0,0.08)" } }}
    >
      <DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center", py: 3, px: 2 }}>
          <StepUpSpinner size="medium" label={title} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingDialog;
